<template>
    <Modal idModal="BoqColumnFilter" :headerTitle="$t('Manage Columns')" modalSize="modal-lg" >
    <div class="boq-column-filter-modal">
        <div class="boq-column-filter-modal__notice">
            <span class="boq-column-filter-modal__notice-icon">
                <i class="fa-solid fa-circle-info"></i>
            </span>
            <div>
                <strong>{{ $t('Manage Columns') }}</strong>
                <small>{{ $t('Tick a Checkbox to Hide and Show Columns')}}</small>
            </div>
        </div>
        <div class="boq-column-filter-modal__toolbar">
            <label for="checker-col-checkall" class="boq-column-filter-modal__checkall">
                <input type="checkbox" @change="CheckAll" id="checker-col-checkall" role="button" :checked="allColumnsSelected" />
                <span>{{ allColumnsSelected ? $t('Uncheck') : $t('Check') }} {{ $t('All') }}</span>
            </label>
            <span class="boq-column-filter-modal__count">{{ selectedColumnCount }} / {{ columnSet.length }}</span>
        </div>
        <div class="boq-column-filter-modal__groups">
            <section class="boq-column-filter-modal__group" v-for="(item, key) in ColumnGroupings" :key="key" >
                <label class="boq-column-filter-modal__group-title" :for="'checker-col-group-' + key" >
                    <input
                    type="checkbox"
                    @change="(e)=>{CheckGroup(e,item.columns)}"
                    :id="'checker-col-group-' + key"
                    role="button"
                    :checked="IsGroupChecked(item.columns)"
                    :indeterminate.prop="IsGroupPartial(item.columns)"
                    />
                    <span>{{item.name}}</span>
                </label>

                <div class="boq-column-filter-modal__options">
                    <label class="boq-column-filter-modal__option" v-for="(itemCol, keyCol) in item.columns" :key="keyCol">
                        <input type="checkbox" :value="itemCol.value" v-model="selectedColumn" />
                        <span>{{ $t(itemCol.translationKey || itemCol.name) }}</span>
                    </label>
                </div>
            </section>
        </div>
        
    </div>
    <template v-slot:actions>
        <button type="button" ref="closeModalImportBoq" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
        <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" @click="ShowColumns"  > <i class="fa-solid fa-table-columns"></i> {{ $t('Show Selected Columns') }}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/layout/Modal.vue'
import {BoQColumnList} from '@/helpers/utilities.js'
export default {
    name : 'ModalLineItemColumnFilter',
    props : ['UpdateSelectedColumn'],
    components : {
        Modal
    },
    data (){
        const self = this
        return {
            columnSet : BoQColumnList,
            selectedColumn :  [],
            checkedAll : false,
            groupCheck : [],
            ColumnGroupings : [
                {
                    name : self.$i18n.t('Quantity Columns'),
                    columns : BoQColumnList.filter(u=>u.group==1)
                },
                {
                    name : self.$i18n.t('Cost Rate Columns'),
                    columns : BoQColumnList.filter(u=>u.group==2)
                },
                {
                    name : self.$i18n.t('Total Cost Columns'),
                    columns : BoQColumnList.filter(u=>u.group==3)
                },
                {
                    name : self.$i18n.t('Mark Up'),
                    columns : BoQColumnList.filter(u=>u.group==4)
                },
                {
                    name : self.$i18n.t('Sell Rate Columns'),
                    columns : BoQColumnList.filter(u=>u.group==5)
                },
                {
                    name : self.$i18n.t('Total Sell Columns'),
                    columns : BoQColumnList.filter(u=>u.group==6)
                },
                {
                    name : self.$i18n.t('Gross Profit Columns'),
                    columns : BoQColumnList.filter(u=>u.group==7)
                }
            ]
        }
    },
    mounted() {
        const cols = window.localStorage.getItem('lineItemColumns')
        if(cols){
            this.selectedColumn = cols.split(',').map(Number)
        }else{
            this.selectedColumn = [3,10,13,14,17,20,23]
            window.localStorage.setItem('lineItemColumns',this.selectedColumn)
        }
    },
    computed : {
        isDeluxeLayout(){
            return this.$route.meta.layout == 'deluxe'
        },
        allColumnValues(){
            return BoQColumnList.map(u=>Number(u.value))
        },
        allColumnsSelected(){
            return this.allColumnValues.length > 0 && this.allColumnValues.every(value=>this.selectedColumn.indexOf(value) > -1)
        },
        selectedColumnCount(){
            return this.selectedColumn.length
        }
    },
    // watch : {
    //     selectedColumn(value){
    //         console.log(value)
    //         // this.UpdateSelectedColumn(value)
    //         // window.localStorage.setItem('lineItemColumns',value)
    //     }
    // },
    methods :{
        CheckAll(e){
            const checked = e.target.checked
            const all = this.allColumnValues
            this.groupCheck = []
            if(checked)
                this.selectedColumn = all
            else
                this.selectedColumn = []
            
        },
        ClickTr(value){
            const getIndex = this.selectedColumn.indexOf(value)

            if(getIndex==-1)
                this.selectedColumn.push(Number(value))
            else{
                this.selectedColumn.splice(getIndex,1)
            }

            // this.UpdateSelectedColumn(this.selectedColumn)
            // window.localStorage.setItem('lineItemColumns',this.selectedColumn)
        },
        HasColumn(value){
            return this.selectedColumn.indexOf(Number(value)) > -1
        },
        IsGroupChecked(columns){
            return columns.length > 0 && columns.every(u=>this.HasColumn(u.value))
        },
        IsGroupPartial(columns){
            const selectedCount = columns.filter(u=>this.HasColumn(u.value)).length
            return selectedCount > 0 && selectedCount < columns.length
        },
        ShowColumns(){
            const sorted = this.selectedColumn.sort(function(a, b) {
            return a - b;
            })
            this.UpdateSelectedColumn(JSON.parse(JSON.stringify(sorted)))
            window.localStorage.setItem('lineItemColumns',sorted)
            this.$refs.closeModalImportBoq.click()
        },
        CheckGroup(e,columns){
            const checked = e.target.checked

            let data = columns.map(u=>Number(u.value))

            if(checked){
                this.selectedColumn.push(...data.filter(u=>this.selectedColumn.indexOf(u)== -1))
            }else{
                this.selectedColumn = this.selectedColumn.filter(u=>data.indexOf(u) == -1)
            }
        }
    }
}
</script>
